import { render, staticRenderFns } from "./SwiperNew.vue?vue&type=template&id=dc89c800&scoped=true&"
import script from "./SwiperNew.vue?vue&type=script&lang=js&"
export * from "./SwiperNew.vue?vue&type=script&lang=js&"
import style0 from "./SwiperNew.vue?vue&type=style&index=0&id=dc89c800&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc89c800",
  null
  
)

export default component.exports